import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=e9872370&scoped=true&"
import script from "./BasePagination.vue?vue&type=script&lang=js&"
export * from "./BasePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9872370",
  null
  
)

export default component.exports